/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Cash_FlowInputs */

const en_nav_cash_flow = /** @type {(inputs: Nav_Cash_FlowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cash Flow (AR)`)
};

const es_nav_cash_flow = /** @type {(inputs: Nav_Cash_FlowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Flujo de caja (CxC)`)
};

/**
* | output |
* | --- |
* | "Cash Flow (AR)" |
*
* @param {Nav_Cash_FlowInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const nav_cash_flow = /** @type {((inputs?: Nav_Cash_FlowInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Cash_FlowInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nav_cash_flow(inputs)
	return es_nav_cash_flow(inputs)
});